<template>
  <div class="animated">
      <b-card-header class="custom-header">
        <div><i class="icon-note"></i>Financial Reports{{ client_id ? " - Edit" : " - View"}}</div>
          <!-- <router-link :to="`/customers/financialReports`" class="link">        
            <b-button class="custom-cancel"><i class="fa fa-times text-danger"></i>
               Close
            </b-button>
          </router-link> -->

          <router-link :to="`/customers/financialReports`" class="link">
          <b-button>
            <i class="fa fa-times text-danger"></i>&nbsp;Close
          </b-button>
        </router-link> 

      </b-card-header>
        <b-row>
          <b-col md="9" class="no-padding">
            <div> 
            <b-tabs>
              
              <!-- ### Hitory TAB ### -->
              <b-tab title="Hitory">
                  <b-card-body v-if="isLoading">
                  <spinner></spinner> 
                  </b-card-body>      
                    <v-client-table id="dataTable" v-else> 
                    </v-client-table>
              </b-tab>


              <!-- ### Place TAB ### -->
              <b-tab title="Place">
                <mapChart
                    class="chart-wrapper"
                    ref="mapchart"
                    >
                </mapChart>
              </b-tab>
            </b-tabs>

          </div>

          </b-col>

          <b-col md="3" class="no-padding">
            <b-card class="customers">
             <h3 class="text-center">Customers</h3>
                <h5>Name</h5>
                <p class="gray f-16">{{nameTitle}}  {{nameFirstname}}  {{nameLastname}}</p>
                <h5>Email</h5>
                <p class="gray f-16">{{email}}</p>
                <h5>Address</h5>
                <p class="gray f-16">{{addressLine1}} {{addressLine2}} {{addressCity}} {{addressState}} {{addressCountry}} {{addressZipcode}}</p>
            </b-card>
            
          </b-col>
        </b-row>
  </div>

</template>

<script>
import Vue from 'vue';
import VueNotifications from 'vue-notifications';
import Chart from "./chart";
import mapChart from "./mapChart";
import miniToastr from 'mini-toastr';
import { validationMixin } from "vuelidate";
import { required, minLength, email, sameAs, helpers, url, alpha } from "vuelidate/lib/validators";
import { Switch as cSwitch } from '@coreui/vue';
import { router } from '../../router/index';
import {ClientTable, Event} from 'vue-tables-2';
import {apigClient} from '@/shared/api';
import moment from 'moment';
import 'moment-timezone';

const Spinner = () => import('../shared/Spinner');
const toastTypes = {
  success: 'success',
  error: 'error',
  info: 'info',
  warn: 'warn'
}
miniToastr.init({types: toastTypes})
function toast ({title, message, type, timeout, cb}) {
  return miniToastr[type](message, title, timeout, cb)
}
const options = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast
}
Vue.use(VueNotifications, options);
  Vue.use(ClientTable);
let columns = ['action', 'eventName', 'evantType'];
  
  let headings = {
    action: '',
    evenName: 'evenName',
    evanType: 'evanType',
};
  let sortable = ['eventName', 'evantType'];
  let filterable = ['eventName', 'evantType'];

export default {
  name: "Financial",
  components: {
    cSwitch,
    Spinner,
    mapChart,
    Chart,

  },
  data() {
    let loginUserInfo = JSON.parse(localStorage.getItem("loginUserInfo"));
    let userTimezone = loginUserInfo.db.timezone || 'Asia/Bangkok';
    if(window.location.href.includes("/customers/financialReports/view")){
      var client_id = localStorage.getItem('page_financialReports_id');
    }
    return {
      loginUserInfo: loginUserInfo,
      userTimezone : userTimezone,
      feedBack: 'secondary',
      disabled: true,
      isLoading: true,
      client_id: client_id ||null,
      nameTitle: null,
      nameFirstname: null,
      nameLastname: null,
      email: null,
      location: null,
      stage: null,
      stage: null,
      points: null,
      lastActive: null,
      addressLine1: null,
      addressLine2: null,
      addressCity: null,
      addressZipcode: null,
      addressState: null,
      addressCountry: null,
      columns: columns, 
        data: [],
        options: {
          headings: headings,
          sortable: sortable,
          filterable: filterable,
          sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
          pagination: {
            chunk: 5,
            edge: false,
            nav: 'scroll'
          }
        },
        useVuex: false,
        theme: 'bootstrap4',
        template: 'default',
    }
  },
  

  mounted: function(){
    this.getClientsData();
  },
  computed: {
    formStr() { return JSON.stringify(this.form, null, 4) },
    isValid() { return !this.$v.form.$anyError },
    isDirty() { return this.$v.form.$anyDirty },
  },
  mixins: [validationMixin],
  methods: {
    getPlatformType: function(platformType) {
      this.platformTypeSelected = platformType;
      this.form.fullDomainName = platformType === 'white-label' ? this.fullDomainNameTmp : '';
      if (platformType === 'white-label') {
        this.chkState('fullDomainName');
      }
      this.form.fullDomainName = platformType === 'full white-label' && (this.form.fullDomainName === 'NULL' && (this.form.fullDomainName.length === 0)) ? '' : this.form.fullDomainName;
    },
    loadData: function(email) {
        var method = 'GET';
        var pathTemplate = '/financialReportsRecords';
        var additionalParams ={
          queryParams: {
            params: JSON.stringify({
              filter: [
                {
                  fieldname: "financialReports_email",
                  comparisonOperator: "=",
                  value: email
                }
              ]
            })
          }
        };
        var pathParams = {};
        var userDatas = [];
        var that = this;
        apigClient.invokeApi(pathParams, pathTemplate, method, additionalParams)
        .then(function(result){
          if (result.data.status) {
            let data = result["data"]["data"].map((elem, index) => { 
                elem.index = index;
                elem.evantType = elem.eventType;
                elem.eventName = elem.eventName ;
                elem.eventTimestamp = elem.eventTimeStamp;
                elem.eventTimestamp = moment(moment.unix(elem.eventTimeStamp)).tz(that.userTimezone).format('YYYY-MM-DD HH:mm');
                return  elem;
            }); 
             that.data = [...data];
            //  that.initMap(data);
             that.$refs.mapchart.initMap(data);
             that.$refs.chart.getChartData(data,that.userTimezone);
          } else {
             that.showErrorMsg({message: result.data.message});
          }
          that.isLoading = false;
        }).catch( function(error){
          that.showErrorMsg({message: error.message});
          that.isLoading = false;
        });
      },
    routerBack(){
      this.$router.go(-1);
    },
    getClientsData: function() {
        var method = 'GET';
        var pathTemplate = '/financialReports/'+this.client_id;
        var additionalParams ={};
        var pathParams = {};
        var userDatas = [];
        var that = this;
        apigClient.invokeApi(pathParams, pathTemplate, method, additionalParams)
        .then(function(result){
          if (result.data.status) {
            var datas = result["data"]["data"];
                that.client_id = datas.id;
                that.nameTitle = datas.nameTitle ;
                that.nameFirstname = datas.nameFirstname ;
                that.nameLastname = datas.nameLastname ;
                that.email = datas.email;
                that.location = datas.location;
                that.stage = datas.stage;
                that.points = datas.points;
                that.lastActive = datas.lastActive;
                that.addressLine1 = datas.addressLine1;
                that.addressLine2 = datas.addressLine2;
                that.addressCity = datas.addressCity;
                that.addressZipcode = datas.addressZipcode;
                that.addressState = datas.addressState;
                that.addressCountry = datas.addressCountry;
                that.loadData(datas.email);
                
          } else {
             that.showErrorMsg({message: result.data.message});
          }
          that.isLoading = false;
        }).catch( function(error){
          that.showErrorMsg({message: error.message});
          that.isLoading = false;
        });
      },
  },
  notifications: {
    showSuccessMsgCreate: {
      type: VueNotifications.types.success,
      title: 'Operation successfull!',
      message: 'The Customer Client data has been create'
    },
    showSuccessMsgUpdate: {
      type: VueNotifications.types.success,
      title: 'Operation successfull!',
      message: 'The Customer Client data has been update'
    },
    showInfoMsg: {
      type: VueNotifications.types.info,
      title: 'Info',
      message: 'Here is some info for you'
    },
    showWarnMsg: {
      type: VueNotifications.types.warn,
      title: 'Warning',
      message: 'That\'s the kind of warning'
    },
    showErrorMsg: {
      type: VueNotifications.types.error,
      title: null,
      message: ''
    }
  },
  

}
</script>



<style scoped>
#map{
  height: 32em;
}
  .btn.disabled {
    cursor: auto;
  }
  .custom-header{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .btn-group > .btn, .btn-group-vertical > .btn {
      border: 1px solid #a4acb5;
  }
  @media only screen and (max-width: 600px) {
    .custom-header{
      flex-direction: column;
      align-items: inherit;
    }
    .custom-header > div:first-child {
      margin-bottom: 10px;
    } 
  }
  .custom-cancel {
    border-radius: 0.25rem 0 0 0.25rem;
  }
  .sk-fading-circle .sk-circle {
    margin: 0 auto;
  }
  .sk-three-bounce {
    height: 40px;
  }
  label {
    font-weight: 600!important;
  }
</style>

<style>
  #language {
    margin-top: 15px;
  }
  .custom-header{
    display: flex;
    justify-content: space-between;
  } 
  select {
    /* for Firefox */
    -moz-appearance: none;
    /* for Chrome */
    -webkit-appearance: none;
  }
  /* For IE10 */
  select::-ms-expand {
    display: none;
  }
  .tech-image{
    height:15px;
  }
  .form-group label.required:after {
    content: " *";
    color: #f86b4f;
  }
  .color-20a8d8{
    color:#20a8d8;
  }
  .underline{
    text-decoration: underline;
  }
  .font-size-13{
    font-size:13px !important;
  }
  .color-red{
    color:red;
  }
  .margin-bottom-5{
    margin-bottom: 5px;
  }
  .sk-cube-grid .sk-cube {
  background-color: #16a4d3;
}
.row{
  margin: 0.5em 0.5em 0.5em 0.5em !important;
}
.no-padding{
    padding: 0.1em !important;
}
.customers{
  height: 70em;
}


</style>
<style lang="scss">
  #dataTable {
    width: 95%;
    margin: 0 auto;

    .VuePagination {
      text-align: center;
      justify-content: center;
    }

    .vue-title {
      text-align: center ;
      margin-bottom: 10px;
    }

    .VueTables__search-field {
      display: flex;
    }
    .VueTables__search-field input {
      margin-left: 0.25rem;
    }

    .VueTables__limit-field {
      display: flex;
    }

    .VueTables__limit-field select {
      margin-left: 0.25rem !important;
    }

    .VueTables__table th {
      text-align: center;
    }

    .VueTables__child-row-toggler {
      width: 16px;
      height: 16px;
      line-height: 16px;
      display: block;
      margin: auto;
      text-align: center;
    }
    
    .action{
      display: flex;
      justify-content: center;
      align-items: center;
    } 
  }
  #dataTable {
    margin: 18px auto;
  }
  .active-disabled .switch-pill .switch-slider{
    opacity: 1 !important;
  }
  .hyperlink-without-href{
    color: #20a8d8 !important;
    text-decoration: none !important;
    background-color: transparent !important;
  }

  .hyperlink-without-href:hover{
    color: #20a8d8 !important;
    cursor: pointer;
    text-decoration: underline !important;
  }
.f-16{
  font-size: 16px;
}
</style>